(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("dieselSendNotification", {
            parent: "Notification",
            url: "/notification/diesel-send",
            data: {
                authorities: ["bilioslo-admin-dieselvarsel"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/notification/diesel-send/diesel-send.html",
                    controller: "DieselSendNotificationController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();
